import { FormattedMessage, FormattedNumber } from 'react-intl';
import { dealInfoHelpers } from 'widget/player-widget';

import { WixConnect } from 'shared/utils/wix-connect';
import { isSubscriptionButtonVisible } from 'shared/utils/layout-helpers';

import { LinkButton } from 'shared/components/button/button';

import translations from './translations';
import styles from './channel-actions.styl';


@WixConnect(styles)
export default class ChannelSubscriptionButton extends React.Component {

  static propTypes = {
    channelData: React.PropTypes.object,
    className: React.PropTypes.string,
    onClick: React.PropTypes.func,
  };

  render() {
    const { channelData, className, onClick } = this.props;

    if (!isSubscriptionButtonVisible(channelData)) {
      return null;
    }

    const subscriptionPriceInfo = dealInfoHelpers.getSubscriptionPriceInfo(channelData.dealInfo);

    const values = {
      price: <FormattedNumber value={subscriptionPriceInfo.price}
                              style="currency"
                              currency={subscriptionPriceInfo.currency} />,
    };

    return (
      <LinkButton className={`qa-channel-subscription ${className}`}
                  styleName="action subscribe"
                  onClick={onClick}>
        <FormattedMessage {...translations.subscribe}
                          values={values} />
      </LinkButton>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/components/channel-actions/channel-subscription-button.js